// extracted by mini-css-extract-plugin
module.exports = {"treeWrapper":"DetailTree_treeWrapper__1DarM","headerRow":"DetailTree_headerRow__3vk-a","treeHeader":"DetailTree_treeHeader__1Ly7O"};